export default {
  data() {
    return {
      map: null
    };
  },

  mounted() {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    self.map = new google.maps.Map(document.getElementById('adjustmap'), {
      center: {
        lat: parseFloat(self.location.latitude),
        lng: parseFloat(self.location.longitude)
      },
      zoom: 19,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.HYBRID // mapTypeControl:true,
      // mapTypeControlOptions:{
      //     mapTypeIds:[google.maps.MapTypeId.HYBRID, google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN],
      //     position: google.maps.ControlPosition.LEFT_TOP,
      //     style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      // }

    });
  },

  methods: {
    suggest() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.dialog.confirm("Are you sure you want to suggest this adjustment?", function () {
        self.$app.request({
          url: Url.to("location/suggest-adjust"),
          method: "POST",
          data: {
            location_id: self.location.id,
            lat: self.map.center.lat(),
            lng: self.map.center.lng()
          },
          preloader: true,
          indicator: false,
          progress: false,
          success: function (data, status, xhr) {
            console.log(data);
            self.$app.dialog.alert("Adjustment suggestion successfully sent.");
            self.$router.back();
          }
        });
      });
    },

    setCurrentLocation() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (navigator.geolocation) {
        app.dialog.preloader("Please wait");
        navigator.geolocation.getCurrentPosition(function (position) {
          app.dialog.close(); //console.log(position, self.map.setCenter, self.map);

          self.map.setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        }, function (error) {
          console.log(error);

          if (error.message) {
            self.$app.dialog.alert(error.message);
          } else {
            if (error.code === error.PERMISSION_DENIED) {
              self.$app.dialog.alert('Unable to access your location. ' + 'Please allow this application to access location data.');
            }

            if (error.code === error.POSITION_UNAVAILABLE) {
              self.$app.dialog.alert('Unable to access your location. Please enable location services in your device.');
            }

            if (error.code === error.TIMEOUT) {
              self.$app.dialog.alert('Unable to access your location due to low signal,  please try again.');
            }
          }

          app.dialog.close();
        });
      }
    }

  },
  id: 'd965e8691e',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar white-large-toolbar " data-name="adjust-location"\n         style="--f7-toolbar-height: 80px;">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a class="link back icon-only" href="#">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Adjust Location</div>\n                <div class="right">\n                    <a href="#" class="link icon-only" @click="setCurrentLocation">\n                        <i class="icon material-icons">gps_fixed</i>\n                    </a>\n                </div>\n            </div>\n        </div>\n\n        <div class="toolbar toolbar-bottom">\n            <div class="toolbar-inner padding-horizontal">\n                <div class="row width-100">\n                    <div class="col-100 ">\n                        <a @click="suggest" class="button button-fill button-raised button-large width-100"\n                           href="#">\n                            Send Suggestion\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="block map-block no-margin no-padding" style="height: 100%">\n                <div style="width:100%;height:100%;position: relative">\n                    <div class="center-marker"></div>\n                    <div id="adjustmap" style="width:100%;height:100%;">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};